/* product detail */
var descPos = 0;
function isMoreClick(e) {
  this.target.classList.remove('is-shorten');
  this.btn.classList.remove('is-shorten');
  this.desc.classList.remove('is-shorten');
}
function isCloseClick(e) {
  this.target.classList.add('is-shorten');
  this.btn.classList.add('is-shorten');
  this.desc.classList.add('is-shorten');
  window.scrollTo({ top: descPos, behavior: 'smooth' });
}
if(document.querySelector('.product__detail')) {
  // var desc = document.querySelector('.product__detail');
  // var btn = document.querySelector('.btn__more');
  // var closebtn = document.querySelector('.btn__close');
  // var descPos = desc.offsetTop;
  // if(desc.clientHeight > 60) {
  //   desc.classList.add('is-shorten');
  //   btn.classList.add('is-shorten');
  //   closebtn.classList.add('is-shorten');
  //   btn.addEventListener('click', { desc: desc, target: btn, btn: closebtn, handleEvent: isMoreClick });
  //   closebtn.addEventListener('click', { desc: desc, target: closebtn, btn:btn, handleEvent: isCloseClick });
  // } else {
  //   var moreBtn = document.querySelector('.product__moreBtn');
  //   moreBtn.style.display = 'none';
  // }
}

/* product modal */
function openModal(target) {
  const modal = document.querySelector('.product-modal--'+target);
  const closeBtn = modal.querySelector('.product-modal__close');
  closeBtn.addEventListener('click', {modal:modal, closeBtn:closeBtn, handleEvent:closeModal})
  modal.showModal();
}
function closeModal(e) {
  this.modal.close();
  this.closeBtn.removeEventListener('click',closeModal);
}

/* related products */
// var fetchUrl = "".concat(window.routes.searchUrl ? window.routes.searchUrl : "search/").concat(this.element.getAttribute('data-section-id'), "&type=product");
// console.log(fetchUrl);
// fetchUrl = fetchUrl + "&q=" + encodeURIComponent("id:* OR exclude:"+this.options['productId'])
// if(this.options['vendor']){
//   fetchUrl = fetchUrl + "&filter.p.vendor=" + encodeURIComponent(this.options['vendor']);
// }
// if(this.options['type']){
//   fetchUrl = fetchUrl + "&filter.p.product_type=" + encodeURIComponent(this.options['type']);
// }
// if(this.options['category']){
//   fetchUrl = fetchUrl + "&filter.p.m.my_fields.category=" + encodeURIComponent(this.options['category']);
// }
